

























































































































































































































































import { FormFieldDefMap } from '@/reusable/Form/formUtils';
import FormFieldsContainer from '@/reusable/Form/FormFieldsContainer.vue';
import { Vue, Component, Prop, Watch } from 'vue-property-decorator';
import CabeceraModal from '@/reusable/Modal/CabeceraModal.vue';
import ModalMantenedor from '@/reusable/Modal/ModalMantenedor.vue';
import { LoadingService } from '@/services/loadingService';
import { Snotify } from '@/snotify/Snotify';
import CrudStepsNavBar from '@/reusable/Mantenedor/CrudStepsNavBar.vue';
import { PasosCrud } from '@/reusable/Mantenedor/mantenedorUtils';
import ContenidoModal from '@/reusable/Modal/ContenidoModal.vue';
import TextField from '@/reusable/Form/TextField.vue';
import config from '@/config/index';
import { AxiosResponse } from 'axios';
import { MSResponse } from '@/interfaces/MS';
import { Validator } from 'vee-validate';
import ValidaRut from '@/config/validaRut';
import { EstadoEntidad, TipoSim, ServicioProxy } from '@/config/enums';
import { fetchSMS } from '@/pantallas/TorreControl/fetchSMS';
import { AxiosVue } from '@/AxiosVue';
import { ValidarIMEI } from '@/config/validarIMEI';
import { EstadoInterface } from '@/interfaces/Estado';
import { EstadosService } from '@/services/estadosService';

@Component({
  components: {
    CabeceraModal,
    ModalMantenedor,
    CrudStepsNavBar,
    ContenidoModal,
    TextField,
    FormFieldsContainer,
  },
})
export default class CreacionDeGpsSim extends Vue {
  @Prop({ default: false }) show!: boolean;
  @Prop({ default: false }) isTrack3!: boolean;
  @Prop({ default: '' }) patente!: string;
  @Prop({ default: {} }) params!: any;
  respuesta: any;
  dictionaryFormErrors: any = {};
  readonly $snotify: Snotify;
  readonly loadingService = new LoadingService();
  vr: ValidaRut = new ValidaRut();
  id_cotizacion: string = '';
  pasoActivoIndex = 1;
  axios: AxiosVue = new AxiosVue(ServicioProxy.Gps);
  clientId: string = '';
  estadosServices: EstadosService = new EstadosService();
  estados: EstadoInterface[] = this.estadosServices.getEstadosVisibles();
  pasos: PasosCrud = {
    requerimiento: {
      accion: 'Configuración Extra',
      visible: true,
      step: 1,
      title: 'Configuración Extra',
      icon: 'ballot',
      formState: {
        entity: null,
        validator: null,
        isDirty: false,
      },
    },
  };
  userData: any = {};
  marcasGps: any = [];
  modelosGps: any = [];
  tiposSim: any = [];
  companiasTelco: any = [];
  selectedCia: any = [];

  formFields: any = {
    serie: {
      label: 'Nro.Serie',
      id: 'serie',
      value: '',
    },
    selectedTipoGps: {
      label: 'Marca de GPS',
      id: 'marca',
      value: '',
    },
    selectedModelo: {
      label: 'Modelo de GPS',
      id: 'modelo',
      value: '',
    },
    imei: {
      label: 'IMEI',
      id: 'imei',
      value: '',
    },
    estado: {
      label: 'Estado',
      id: 'estado',
      value: EstadoEntidad.Activo,
    },
    numeroSIM: {
      label: 'Número SIM',
      id: 'numSim',
      value: '',
    },
    selectedTipoSim: {
      label: 'Tipo SIM',
      id: 'tipoSim',
      value: '',
    },
    selectedCia: {
      label: 'Cía. Telecomunicaciones',
      id: 'cia',
      value: [],
    },
    numeroTelefonico: {
      label: 'Teléfono Celular',
      id: 'numeroTelefonico',
      value: '',
    },
  };

  formFields2: any = {
    numeroTelefonico: {
      label: 'Teléfono Celular',
      id: 'numeroTelefonico',
      value: '',
    },
    marca: {
      label: 'Marca de GPS',
      id: 'marca',
      value: '',
    },
    modelo: {
      label: 'Modelo de GPS',
      id: 'marca',
      value: '',
    },
  };

  readonly GpsController: string = 'Gps';
  readonly controllerSim: string = 'Sim';
  validarIMEI: ValidarIMEI = new ValidarIMEI();

  constructor() {
    super();
  }

  // Si no tiene configurado marca o modelo, se mostrará modal gps
  get hasGps(){
    if(this.params.marca.toLowerCase() == 'no configurado' || this.params.modelo.toLowerCase() == 'no configurado'){
      return true;
    }
    return false;
  }

  // Si no tiene configurado marca o modelo, se mostrará modal sim
  get hasSim(){
    if(this.params.telefono.toLowerCase() == 'no configurado'){
      return true;
    }
    return false;
  }


  created() {
    let self = this;
    this.getClientId();
    Validator.extend('numeroSerieUnico', {
      getMessage(field: any, params: any, data: any) {
        return '* Número de serie se encuentra en uso.';
      },
      async validate(value: any) {
        try {
          const response = await self.axios.http.get(
            `${self.GpsController}/0/${self.clientId}/${value}`
          );
          return new Promise(resolve => {
            resolve({
              valid: response.data,
              data: response.data
                ? undefined
                : { message: '* Número de serie se encuentra en uso.' },
            });
          });
        } catch (err) {
          return true;
        }
      },
    });
    Validator.extend('IMEIUnico', {
      getMessage(field: any, params: any, data: any) {
        return '* IMEI se encuentra en uso.';
      },
      async validate(value: any) {
        try {
          const response = await self.axios.http.get(
            `${self.GpsController}/0/${value}/ChequearIMEI`
          );
          return new Promise(resolve => {
            resolve({
              valid: response.data,
              data: response.data
                ? undefined
                : { message: '* IMEI se encuentra en uso.' },
            });
          });
        } catch (err) {
          return true;
        }
      },
    });

    Validator.extend('IMEI', {
      getMessage(field: any, params: any, data: any) {
        return (data && data.message) || '* IMEI inválido.';
      },
      validate(value: any) {
        return new Promise(resolve => {
          resolve({
            valid: self.validarIMEI.validar(value.toString()),
            data: self.validarIMEI.validar(value.toString())
              ? undefined
              : { message: '* IMEI inválido.' },
          });
        });
      },
    });

    Validator.extend('numeroSimUnico', {
      getMessage(field: any, params: any, data: any) {
        return '* SIM se encuentra en uso.';
      },
      async validate(value: any) {
        try {
          const response = await self.axios.http.get(
            `${self.controllerSim}/0/${value}/ChequearSim`
          );
          return new Promise(resolve => {
            resolve({
              valid: response.data,
              data: response.data
                ? undefined
                : { message: '* SIM se encuentra en uso.' },
            });
          });
        } catch (err) {
          return true;
        }
      },
    });

    this.getMarcas();
    this.userData = JSON.parse(localStorage.getItem('user'));
  }

  mounted() {
    let self = this;

    for (let item in TipoSim) {
      if (!isNaN(Number(item))) {
        let nombre = TipoSim[item];
        this.tiposSim.push({
          id: Number(item),
          nombre: nombre,
        });
      }
    }

    this.dictionaryFormErrors = {
      custom: {
        serie: {
          required: () => config.errorMensajes.textoRequerido,
          max: config.errorMensajes.maxLength,
          numeroSerieUnico: 'Número de serie se encuentra en uso.',
          alpha_num: () =>
            '* El Número de serie solo debe contener números y/o letras.',
        },
        marca: {
          required: () => config.errorMensajes.textoRequerido,
        },
        modelo: {
          required: () => config.errorMensajes.textoRequerido,
          max: config.errorMensajes.maxLength,
        },
        imei: {
          required: () => config.errorMensajes.textoRequerido,
          max: config.errorMensajes.maxLength,
          IMEIUnico: 'IMEI se encuentra en uso.',
          estado: {
            required: () => config.errorMensajes.textoRequerido,
          },
        },
        numSim: {
          required: () => config.errorMensajes.textoRequerido,
          max: config.errorMensajes.maxLength,
          numeric: config.errorMensajes.soloNumeros,
        },
        tipoSim: {
          required: () => config.errorMensajes.textoRequerido,
          max: config.errorMensajes.maxLength,
        },
        cia: {
          required: () => config.errorMensajes.textoRequerido,
          max: config.errorMensajes.maxLength,
        },
        numeroTelefonico: {
          required: () => config.errorMensajes.textoRequerido,
          max: config.errorMensajes.maxLength,
          regex: config.errorMensajes.regex,
          numeric: config.errorMensajes.soloNumeros,
        },
      },
    };
    this.$validator.localize('es', this.dictionaryFormErrors);
  }

  @Watch('show')
  onPropertyChanged(value: boolean, oldValue: boolean) {
    this.marcasGps = [];
    this.modelosGps = [];
    this.$validator.reset();
    if (value) {
      this.loadingService.showLoading();
      this.getMarcas();
      // this.getDispositivos();
    }
    /*this.estadoSeleccionado = EstadoEntidad.Activo; //Estado Activo

    this.warningInactivo = '';
    this.guardarInactivo = false;
    this.mensajeConfirmacionInactivo = this.$t('mensajes.crud.crear.mensaje', {
      entidad: 'el GPS',
    });*/
  }

  getClientId() {
    this.clientId = localStorage.getItem('clienteDefecto');
  }

  async guardar() {
    this.loadingService.showLoading();
    let errors = await this.$validator.validateAll();
    console.log(errors);
    if (!errors) {
      this.$snotify.error('Existen campos sin completar', {
        timeout: 3000,
      });
      this.loadingService.hideLoading();
      return;
    }
    let self = this;
    let body: any = {};
    if (this.isTrack3) {
      let dataForm = this.formFields;
      body['nombreCia'] = this.companiasTelco.find(
        (x: any) => x.id === dataForm.selectedCia.value
      );
    }
    let dataForm = this.isTrack3 ? this.formFields : this.formFields2;
    for (let key in dataForm) {
      body[key] = dataForm[key].value;
    }
    // body['formData'] = this.isTrack3 ? this.formFields : this.formFields2;
    body['userId'] = this.userData.id;
    body['clientId'] = this.clientId;
    body['patente'] = this.patente;
    body['isTrack3'] = this.isTrack3;

    // Para integracion
    if(!this.isTrack3){
      body['numeroTelefonico'] = body['numeroTelefonico'] != "" ? body['numeroTelefonico'] : this.params.telefono;
      body["hasSim"] = this.hasSim;
      body["hasGps"] = this.hasGps;
    }

    fetchSMS(body, 'saveDataExtra')
      .then((response: any) => {
        if (
          !response.data.hasOwnProperty('CODIGO_RESPUESTA') ||
          response.data.CODIGO_RESPUESTA != '1'
        ) {
          this.$snotify.error(
            response.data.hasOwnProperty('MENSAJE_RESPUESTA')
              ? response.data.MENSAJE_RESPUESTA
              : '[1] Error al enviar los comandos al vehículo'
          );
        } else {
          this.$snotify.success(response.data.MENSAJE_RESPUESTA);
          this.$snotify.success(
            'Ya puede realizar el envío de comandos para este vehículo'
          );
          this.$emit('cerrarCrear');
        }
      })
      .catch((error: any) => {
        console.log(error);
        this.$snotify.error(
          'Error al obtener la respuesta del envío de comandos [send_command]'
        );
      })
      .finally(() => {
        this.loadingService.hideLoading();
      });
  }

  getMarcas() {
    this.axios.http
      .get('gpsMarca')
      .then(res => {
        this.marcasGps = res.data.filter(
          (x: any) => x.estado === EstadoEntidad.Activo
        );
        this.loadingService.hideLoading();
      })
      .catch(err => {
        this.loadingService.hideLoading();
      });
  }

  changeMarca(marca: any) {
    this.axios.http
      .get('gpsModelo/' + marca)
      .then(res => {
        this.modelosGps = res.data.filter(
          (x: any) => x.estado === EstadoEntidad.Activo
        );
      })
      .catch(err => {});
  }

  changeTipoSIM(tipoSim: number) {
    this.axios.http
      .get(`${this.controllerSim}/${tipoSim}/telcos`)
      .then(res => {
        this.companiasTelco = res.data;
        this.formFields.selectedCia.value = [];
        this.$validator.reset(); //Reset Validaciones
      })
      .catch(err => {
        this.companiasTelco = [];
      });
  }

  handleCerrar() {
    this.$emit('cerrarCrear');
  }
}
